// src/components/OverlayDetails.js
import React, { useState, useEffect } from "react";
import { httpClient } from '../../../../HttpClient';

import {
  Building2,
  Users,
  Briefcase,
  FileText,
  HelpCircle,
} from "lucide-react";

const OverlayDetails = ({
  overlayData,
  formatDateWithoutYear,
  selectedYear,
}) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    httpClient
      .get("https://backend-myalfa.vercel.app/api/users")
      .then((res) => setUsers(res.data))
      .catch((err) => console.error(err));
  }, []);

  if (!overlayData) return null;

  const Checkbool = (value) => (
    <div className="flex items-center gap-2">
      <div
        className={`w-4 h-4 rounded-full border flex items-center justify-center
          ${value ? "border-emerald-600" : "border-slate-400"}
        `}
      >
        {value && <div className="w-2 h-2 rounded-full bg-emerald-600" />}
      </div>
    </div>
  );

  const CheckboolS = Checkbool;
  const Tooltip = ({ children, content }) => {
    const [visible, setVisible] = useState(false);

    return (
      <span
        style={{ position: "relative", cursor: "pointer" }}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      >
        {children}
        {visible && <div>{content}</div>}
      </span>
    );
  };

  const { client, suivi, suiviBilan } = overlayData || {};

  const getUserNameByEmail = (email) => {
    if (!email) return "";

    const user = users.find((u) => u.email === email);

    // 🟢 Cas 1 : utilisateur trouvé et infos complètes
    if (user?.name && user?.lastName) {
      return `${user.lastName} ${user.name}`;
    }

    // 🟡 Cas 2 : fallback → on découpe l'email
    const emailPart = email.split("@")[0]; // lastName.name
    if (!emailPart.includes(".")) return email;

    const [lastName, name] = emailPart.split(".");

    const format = (str) =>
      str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

    return `${format(lastName)} ${format(name)}`;
  };

  return (
    <div className="w-full py-6 px-10">
      <div className="text-xs text-slate-600">
        <span className="font-semibold">DOSSIER AGO ANNUEL</span>
        <span className="mx-2">•</span>
        <span>Révision de {selectedYear}</span>
        <span className="mx-2">•</span>
        <span>
          Status : <strong>{suivi?.status}</strong>
        </span>
      </div>
      <h2 className="text-xl font-bold text-slate-900 mt-2">
        {overlayData.client.nom}
      </h2>

      <div>
        <div className="grid grid-cols-2 gap-3">
          <div className="bg-white border border-slate-200 rounded-lg p-3 mt-6">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded bg-pink-100 flex items-center justify-center">
                <Building2 className="w-4 h-4 text-pink-600" />
              </div>
              <h3 className="font-semibold text-sm text-slate-900 m-0">
                Information client
              </h3>
            </div>
            <div className="space-y-2">
              <div className="flex justify-between text-xs">
                <span className="text-slate-500">Forme Juridique</span>
                <span className="font-medium text-slate-900">
                  {client?.formeSociale || "-"}
                </span>
              </div>
              <div className="flex justify-between text-xs">
                <span className="text-slate-500">Régime Fiscal</span>
                <span className="font-medium text-slate-900">
                  {client?.regimeFiscal || "-"}
                </span>
              </div>
              <div className="flex justify-between text-xs">
                <span className="text-slate-500">Régime TVA</span>
                <span className="font-medium text-slate-900">
                  {client?.regimeTVA || "-"}
                </span>
              </div>
              <div className="flex justify-between text-xs">
                <span className="text-slate-500">Collaborateur</span>
                <span className="font-medium text-slate-900">
                  {client?.collaborateur || "-"}
                </span>
              </div>
              <div className="flex justify-between text-xs">
                <span className="text-slate-500">Holding </span>
                <span className="font-medium text-slate-900">
                  {Checkbool(client?.holding)}
                </span>
              </div>
              <div className="flex justify-between text-xs">
                <span className="text-slate-500">Associé Unique ?</span>
                <div
                  className={`w-4 h-4 rounded-full border flex items-center justify-center
      ${
        ["EURL", "SASU"].includes(client?.formeSociale?.[0])
          ? "border-emerald-600"
          : "border-slate-300"
      }
    `}
                >
                  {["EURL", "SASU"].includes(client?.formeSociale?.[0]) && (
                    <div className="w-2 h-2 rounded-full bg-emerald-600" />
                  )}
                </div>
              </div>
              <div className="flex justify-between text-xs">
                <span className="text-slate-500">
                  Si oui, l'associé unique est personne physique est dirigeant ?
                </span>
                <span className="font-medium text-slate-900">
                  {Checkbool(client?.personnePhysique)}
                </span>
              </div>
            </div>
          </div>
          <div className="bg-white border border-slate-200 rounded-lg p-3 mt-6">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded bg-pink-100 flex items-center justify-center">
                <Users className="w-4 h-4 text-pink-600" />
              </div>
              <h3 className="font-semibold text-sm text-slate-900 m-0">
                Équipe Cabinet
              </h3>
            </div>
            <div className="space-y-3">
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-8 h-8 rounded-full bg-pink-600 flex items-center justify-center">
                    <span className="text-white text-xs font-semibold">
                      {client?.email_expertComptable
                        ?.split(" ")
                        .map((n) => n[0])
                        .join("")
                        .toUpperCase() || "EC"}
                    </span>
                  </div>
                  <div>
                    <p className="text-xs font-medium text-slate-900">
                      Expert comptable
                    </p>
                    <p className="text-xs text-slate-600">
                      {getUserNameByEmail(client?.email_expertComptable || "-")}
                    </p>
                  </div>
                </div>
              </div>
              <div className="border-t pt-2">
                <p className="text-[10px] text-slate-500 uppercase mb-1">
                  Collaborateur Niv. 1
                </p>
                <p className="text-xs text-slate-900">
                  {getUserNameByEmail(client?.email_collaborateur || "-")}
                </p>
              </div>
              <div>
                <p className="text-[10px] text-slate-500 uppercase mb-1">
                  {getUserNameByEmail(client?.email_collaborateur_niv2 || "-")}
                </p>
                <p className="text-xs text-slate-900">-</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-4 mt-6">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-8 h-8 rounded bg-pink-100 flex items-center justify-center">
            <Briefcase className="w-4 h-4 text-pink-600" />
          </div>
          <h2 className="font-semibold text-slate-900 text-sm">
            ART. L.223-42, R.223-36 / L.225648 R.225-166 CODE DU COMMERCE
          </h2>
        </div>
        <div className="flex justify-between text-xs">
          <span className="text-slate-500">
            {" "}
            Les capitaux propres sont devenues inférieurs à ½ du capital durant
            l'exercice ?
          </span>
          <span className="font-medium text-slate-900">
            {Checkbool(suivi?.capitauxPropres)}
          </span>
        </div>
        <div
          style={{ display: "flex", gap: "2%", marginTop: "1%", width: "100%" }}
        >
          <p>Si pertes antérieures :</p>
          <div style={{ width: "70%" }}>
            <p>
              <span
                style={{
                  color: "grey",
                }}
              >
                - Exercice ayant constaté la perte :{" "}
              </span>
              {suivi?.exercice || "-"}
            </p>
            <div
              style={{
                display: "flex",
                gap: "2%",
                alignItems: "center",
                width: "100%",
              }}
            >
              <span
                style={{
                  color: "grey",
                }}
              >
                - Les capitaux propres ont été reconstitué durant l'exercice ?
              </span>
              <p>{Checkbool(suivi?.capitauxPopresReconstitue)}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-4 mt-6">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-8 h-8 rounded bg-pink-100 flex items-center justify-center">
            <Briefcase className="w-4 h-4 text-pink-600" />
          </div>
          <h2 className="font-semibold text-slate-900 text-sm">CONVENTION</h2>
        </div>
        <div className="flex justify-between text-xs mb-4">
          <span className="text-slate-500"> Rémunération à approuver :</span>
          <span className="font-medium text-slate-900">
            {Checkbool(suiviBilan?.remuneration)}
          </span>
        </div>
        <div className="flex justify-between text-xs">
          <span className="text-slate-500">
            {" "}
            Convention réglementées à approuver :
          </span>
          <span className="font-medium text-slate-900">
            {Checkbool(suiviBilan?.convention)}
          </span>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-4 mt-6">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-8 h-8 rounded bg-pink-100 flex items-center justify-center">
            <Briefcase className="w-4 h-4 text-pink-600" />
          </div>
          <h2 className="font-semibold text-slate-900 text-sm">
            AFFECTATION DU RESULTAT
          </h2>
        </div>
        <div className="flex justify-between text-xs">
          <span className="text-slate-500"> Résevre légale</span>
          <span className="font-medium text-slate-900">
            {CheckboolS(suiviBilan?.reserveLegale)}
          </span>
          <p>{suiviBilan?.reserveLegaleMontant || "-"} €</p>
          <span className="font-medium text-slate-900 flex">
            <span>{CheckboolS(suiviBilan?.dotee)}</span> &nbsp; &nbsp;Convention
            réglementées à approuver
          </span>
        </div>
        <p style={{ marginTop: "1%" }}> - Dividendes</p>
        <div className="flex justify-between text-xs mb-2">
          <span className="text-slate-500">
            {" "}
            Dispense prélèvement forfaitaire non libératoire :
          </span>
          <span className="font-medium text-slate-900">
            {CheckboolS(suiviBilan?.dispense)}
          </span>
        </div>
        <div className="flex justify-between text-xs  mb-2">
          <span className="text-slate-500">
            {" "}
            Si SARL, montannt sousmis à cotisations sociales :
          </span>
          <span className="font-medium text-slate-900">
            {suiviBilan?.sarl || "-"}
          </span>
        </div>
        <div className="flex justify-between text-xs  mb-2">
          <span className="text-slate-500"> - Autres</span>
          <span className="font-medium text-slate-900">
            {suiviBilan?.aurtres || "-"}
          </span>
        </div>
        <div className="flex justify-between text-xs  mb-2">
          <span className="text-slate-500"> - Report à nouveau</span>
          <span className="font-medium text-slate-900">
            {suiviBilan?.report || "-"}
          </span>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-4 mt-6 flex gap-10">
        <div
          style={{
            borderRight: "1px solid grey",
            paddingRight: "5%",
            width: "50%",
          }}
        >
          {/* En-tête */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "2fr 0.5fr 0.5fr 0.5fr", // 1ère colonne pour labels, 3 colonnes pour cases
              textAlign: "center",
              marginBottom: "5px",
            }}
          >
            <span></span> {/* colonne vide pour le label */}
            <span>OK</span>
            <span>Dispense</span>
            <span>N/A</span>
          </div>

          {[
            { label: "Comptes Annuel", key: "comptesAnnuel" },
            { label: "Courrier", key: "courrier" },
            { label: "Feuille Présence", key: "feuillePresence" },
            { label: "Texte des Résolutions", key: "texteDesResolution" },
            { label: "Rapport Gestion", key: "rapportGestion" },
            { label: "Rapport Convention", key: "rapportConvetion" },
            { label: "Rapport Conseil", key: "rapportConseil" },
            { label: "Rapport CAC", key: "rapportCAC" },
            { label: "Procès Verbal", key: "procésVerbal" },
            { label: "Extrait PV", key: "extraitPV" },
            {
              label: "Déclaration Confidentialité",
              key: "declarationConfidentialite",
            },
            { label: "Pouvoir", key: "pouvoir" },
          ].map((item) => {
            const value = suivi?.[item.key];
            const options = ["OK", "Dispense", "N/A"];

            return (
              <div
                key={item.key}
                style={{
                  display: "grid",
                  gridTemplateColumns: "2fr 0.5fr 0.5fr 0.5fr",
                  alignItems: "center",
                  textAlign: "center",
                  marginBottom: "5px",
                }}
              >
                <span style={{ textAlign: "left" }}>{item.label}</span>
                {options.map((opt) => (
                  <span key={opt}>{value === opt ? "☒" : "☐"}</span>
                ))}
              </div>
            );
          })}
        </div>

        <div style={{ width: "40%" }}>
          <p
            style={{
              textAlign: "center",
            }}
          >
            Formalités / Déclarations
          </p>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <tbody>
              <tr>
                <td
                  style={{
                    fontSize: "13px",
                    textAlign: "left",
                    padding: "10px 0",
                  }}
                >
                  Dépôt Greffe
                </td>
                <td
                  style={{
                    fontSize: "13px",
                    textAlign: "left",
                    padding: "10px 0",
                  }}
                >
                  {suivi?.depotGreffe ||
                    "\u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0 \u00A0"}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    fontSize: "13px",
                    padding: "10px 0",
                    textAlign: "left",
                  }}
                >
                  Récépissé dépôt
                </td>
                <td
                  style={{
                    fontSize: "13px",
                    padding: "10px 0",
                    textAlign: "left",
                  }}
                >
                  {suivi?.recepisse}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    fontSize: "13px",
                    padding: "10px 0",
                    textAlign: "left",
                  }}
                >
                  2777-SD
                </td>
                <td
                  style={{
                    fontSize: "13px",
                    padding: "10px 0",
                    textAlign: "left",
                  }}
                >
                  {suivi?.sd2777}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    fontSize: "13px",
                    padding: "10px 0",
                    textAlign: "left",
                  }}
                >
                  Classement GED
                </td>
                <td
                  style={{
                    fontSize: "13px",
                    padding: "10px 0",
                    textAlign: "left",
                  }}
                >
                  {suivi?.ged}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg p-4 mt-6">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-8 h-8 rounded bg-pink-100 flex items-center justify-center">
            <FileText className="w-4 h-4 text-pink-600" />
          </div>
          <h2 className="font-semibold text-slate-900 text-sm m-0">
            CONFIDENTIALITE DES COMTPES
          </h2>
        </div>
        <p>
          (option exercée en applicatiobn de l'article L.232-25 du code de
          commerce)
        </p>
        <div className="flex items-center gap-2">
          {CheckboolS(suivi?.annuelsComplet)}
          <span>Comptes annuels complets (microentreprises)</span>
          <Tooltip
            content={
              <div className="p-2 bg-white border border-slate-200 rounded shadow text-xs space-y-1">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "100%",
                    marginLeft: "2%",
                  }}
                >
                  <p>
                    - N'est pas une cociété mentionnée à l'article L.123-16-2
                  </p>
                  <p>
                    - N'a pas pour activité la gestion des titres de
                    participations et de valeurs mobilières
                  </p>
                  <p>
                    - Micro-entreprises (L.123-16-1 et de l'article D. 123-200
                    1° Cide comm), ne sont pas dépassés 2 des 3 seuils suivants
                    :{" "}
                  </p>
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "100%",
                    marginLeft: "5%",
                  }}
                >
                  <p>✓ Total du bilan : 450 000 euros</p>
                  <p>✓ Montant du chiffre d'affaires : 900 000 euros</p>
                  <p>
                    ✓ Nombre moyen de salaries employés au cours de l'exercice :
                    10
                  </p>
                </div>
              </div>
            }
          >
            <HelpCircle className="w-4 h-4 text-slate-400 cursor-pointer" />
          </Tooltip>
        </div>
        <div className="flex items-center gap-2">
          {CheckboolS(suivi?.resultatUniquement)}{" "}
          <span>Comptes de résultat uniquement </span>
          <Tooltip
            content={
              <>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "100%",
                    marginLeft: "2%",
                  }}
                >
                  <p>
                    - Petite entreprises (L. 123-16 autre que L. 123-16-2), ne
                    sont pas dépassés 2 des 3 seuils suivants :{" "}
                  </p>
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "100%",
                    marginLeft: "5%",
                  }}
                >
                  <p>✓ Total du bilan : 7 500 000 euros</p>
                  <p>✓ Montant du chiffre d'affaires : 15 000 000 euros</p>
                  <p>
                    ✓ Nombre moyen de salaries employés au cours de l'exercice :
                    50
                  </p>
                </div>
              </>
            }
          >
            <HelpCircle className="w-4 h-4 text-slate-400 cursor-pointer" />
          </Tooltip>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-4 mt-6">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-8 h-8 rounded bg-pink-100 flex items-center justify-center">
            <Users className="w-4 h-4 text-pink-600" />
          </div>
          <h2 className="font-semibold text-slate-900 text-sm">
            DISPENSE ANNEXE :
          </h2>
          <p>{Checkbool(suivi?.dispenseAnnexe)}</p>
        </div>

        <h4>États financiers - Annexe : </h4>

        {/* Micro-entreprise */}
        <div className="flex items-center gap-2">
          {Checkbool(suiviBilan?.microEntreprise)}{" "}
          <span>Dispense d'annexe micro-entreprise ( hors holding ) : </span>
          <Tooltip
            content={
              <>
                <div
                  style={{ display: "grid", gridTemplateColumns: "20% 20%" }}
                >
                  <p>✓ Total du bilan</p>
                  <p>≤ 350 000 Euro</p>
                </div>
                <div
                  style={{ display: "grid", gridTemplateColumns: "20% 20%" }}
                >
                  <p>✓ CA net</p>
                  <p>≤ 700 000 Euro</p>
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "20% 20% 60%",
                    alignItems: "center",
                  }}
                >
                  <p>✓ Nombre moyen de salariés</p>
                  <p>≤ 10</p>
                  <p style={{ fontSize: "0.8rem" }}>
                    (moyenne à la fin de chaque trimestre de l'année civile, ou
                    de l'exercice si différent)
                  </p>
                </div>
              </>
            }
          >
            <HelpCircle className="w-4 h-4 text-slate-400 cursor-pointer" />
          </Tooltip>
        </div>

        {/* Personne physique */}
        <div className="flex items-center gap-2">
          {Checkbool(suiviBilan?.personnePhysique)}{" "}
          <span> Dispense d'annexe personne</span>
          physique :{" "}
          <Tooltip
            content={
              <>
                <div style={{ display: "grid", gridTemplateColumns: "100%" }}>
                  <p>✓ Personne physique</p>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "100%" }}>
                  <p>✓ Régime fiscal : RSI</p>
                </div>
              </>
            }
          >
            <HelpCircle className="w-4 h-4 text-slate-400 cursor-pointer" />
          </Tooltip>
        </div>

        {/* Petite entreprise */}
        <div className="flex items-center gap-2">
          {Checkbool(suiviBilan?.petiteEntreprise)}
          <span>Présentation simplifiée petite-entreprise : </span>
          <Tooltip
            content={
              <>
                <div
                  style={{ display: "grid", gridTemplateColumns: "20% 20%" }}
                >
                  <p>✓ Total du bilan</p>
                  <p>≤ 4 000 000 Euro</p>
                </div>
                <div
                  style={{ display: "grid", gridTemplateColumns: "20% 20%" }}
                >
                  <p>✓ CA Net</p>
                  <p>≤ 8 000 000 Euro</p>
                </div>
                <div
                  style={{ display: "grid", gridTemplateColumns: "20% 20%" }}
                >
                  <p>✓ Nombre moyen de salariés</p>
                  <p>≤ 50</p>
                </div>
              </>
            }
          >
            <HelpCircle className="w-4 h-4 text-slate-400 cursor-pointer" />
          </Tooltip>
        </div>

        {/* Annexe abrégée */}
        <div className="flex items-center gap-2">
          {Checkbool(suiviBilan?.abregee)}{" "}
          <span>Présentation annexe abrégée : </span>
          <Tooltip
            content={
              <>
                <div style={{ display: "grid", gridTemplateColumns: "100%" }}>
                  <p>✓ Personne morale</p>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "100%" }}>
                  <p>✓ Régime fiscal : RSI</p>
                </div>
              </>
            }
          >
            <HelpCircle className="w-4 h-4 text-slate-400 cursor-pointer" />
          </Tooltip>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-4 mt-6">
        <div className="flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-slate-900 mb-3">
          <div className="w-2 h-2 rounded-full bg-[#8B1538]"></div>
          Événements cabinet
        </div>
        {suivi?.historiques && suivi?.historiques.length > 0 ? (
          suivi?.historiques.map((histo) => (
            <div
              key={histo.id}
              style={{
                position: "relative",
                paddingLeft: "20px",
                marginBottom: "15px",
                borderLeft: "2px solid #cbd5e1",
              }}
            >
              {/* Pastille */}
              <div
                style={{
                  position: "absolute",
                  left: "-6px",
                  top: "0",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: "#2563eb",
                  border: "2px solid #fff",
                }}
              ></div>

              {/* Contenu */}
              <div
                style={{
                  background: "#eff6ff",
                  borderRadius: "8px",
                  padding: "10px",
                  border: "1px solid #cbd5e1",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginBottom: "4px",
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      fontWeight: "600",
                      color: "#1e40af",
                    }}
                  >
                    {histo.titre}
                  </p>
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#1e40af",
                    }}
                  >
                    {formatDateWithoutYear(histo.createdAt)}
                  </span>
                </div>

                <p
                  style={{
                    fontSize: "13px",
                    color: "#1e3a8a",
                    marginBottom: "4px",
                  }}
                >
                  {histo.description}
                </p>
              </div>
            </div>
          ))
        ) : (
          <p style={{ fontStyle: "italic", color: "grey" }}>
            Aucun historique pour l'instant
          </p>
        )}
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default OverlayDetails;
